import { ApolloCache, Reference } from '@apollo/client';
import {
  MessageRatingFragment,
  MessageRatingFragmentDoc,
} from '@shared/generated/graphql';

export function writeMessageRatingToCache(
  cache: ApolloCache<unknown>,
  rating: MessageRatingFragment
): void {
  const ratingRef = cache.writeFragment({
    fragment: MessageRatingFragmentDoc,
    fragmentName: 'MessageRating',
    data: rating,
  });
  cache.modify({
    fields: {
      myMessageRatings(existing: readonly Reference[] = [], { readField }) {
        const others = existing.filter(
          (ref) => readField('messageId', ref) !== rating.messageId
        );
        return ratingRef ? [...others, ratingRef] : others;
      },
    },
  });
}

export function removeMessageRatingFromCache(
  cache: ApolloCache<unknown>,
  messageId: string
): void {
  cache.modify({
    fields: {
      myMessageRatings(existing: readonly Reference[] = [], { readField }) {
        return existing.filter(
          (ref) => readField('messageId', ref) !== messageId
        );
      },
    },
  });
}
